import { GET_VENDOR_ID } from "../../constants"

export const vendorID = (ID) => async (dispatch) => {
    dispatch(
        {
            type : GET_VENDOR_ID,
            vendorId : ID
        }
    )
}